import { render, staticRenderFns } from "./cardVerified.vue?vue&type=template&id=aa964e06&scoped=true&"
import script from "./cardVerified.vue?vue&type=script&lang=js&"
export * from "./cardVerified.vue?vue&type=script&lang=js&"
import style0 from "./cardVerified.vue?vue&type=style&index=0&id=aa964e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa964e06",
  null
  
)

export default component.exports